import React, { useState, useEffect } from 'react'

const AdminClients = ({ userDetails }) => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [subClients, setSubClients] = useState(null); // State for sub-clients
  const [activeClientName, setActiveClientName] = useState(null);

  useEffect(() => {
    // Fetch reports only for the logged-in user
    const fetchClients = async () => {
      try {
        const response = await fetch(`http://localhost:3002/api/get-admin-clients?client_id=${userDetails.client_id}`);
        if (!response.ok) {
          throw new Error('Failed to fetch clients');
        }
        const data = await response.json();
        setClients(data); // Store the reports data in state
      } catch (error) {
        console.log(error.message);
      } finally {
        setLoading(false); // Set loading to false after the request completes
      }
    };

    fetchClients();
  }, [userDetails.client_id]);


  // Fetch sub-clients for a particular client
  const fetchSubClients = async (client) => {
    try {
      const response = await fetch(`http://localhost:3002/api/get-admin-clients?client_id=${client.client_id}`);
      if (!response.ok) {
        throw new Error('Failed to fetch sub-clients');
      }
      const data = await response.json();
      setSubClients(data); // Store sub-clients in state
      setActiveClientName(client.name); // Track which client has sub-clients displayed
    } catch (error) {
      console.log(error.message);
    }
  };


  // delete clients
  const deleteClients = async (client) => {
    console.log("Deleting client with ID:", client.id);
    console.log(typeof(client.id));
    
    try {
      const response = await fetch(`http://localhost:3002/api/delete-client?id=${client.id}`, {
        method: 'DELETE', // Ensure this is DELETE
      });


      if (!response.ok) {
        throw new Error('Failed to delete client');
      }

      // Update state to remove the client from the list
      setClients(prevClients => prevClients.filter(c => c.id !== client.id));

      // If the deleted client was a sub-client, update the subClients state
      if (subClients) {
        setSubClients(prevSubClients => prevSubClients.filter(c => c.id !== client.id));
      }

      alert('Client Deleted Successfully');

    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <>
      <section className='py-5'>
        <div className='container'>

          <p className='sec-subheading'><hr /><span>All Clients</span><hr /></p>

          <div className='table-responsive text-center my-4'>
            <table className='w-100'>

              <tr className='bg-light para-text'>
                <th className='py-3 px-2'>S. No</th>
                <th className='py-3 px-2'>Name</th>
                <th className='py-3 px-2'>Phone</th>
                <th className='py-3 px-2'>Role</th>
                <th className='py-3 px-2'>User Id</th>
                <th className='py-3 px-2'>Sub Clients</th>
                <th className='py-3 px-2'>Delete Client</th>
              </tr>

              {loading && <tr><td colSpan='5' className='py-3 px-2'>Loading reports...</td></tr>}

              {clients.length === 0 ? (
                <tr>
                  <td colSpan='5' className='py-3 px-2'>No clients found.</td>
                </tr>
              ) : (
                clients.map((client, index) => (
                  <tr className='text-muted para-text text-capitalize' key={client.id}>
                    <td className='py-3 px-2'>{index + 1}</td>
                    <td className='py-3 px-2'>{client.name}</td>
                    <td className='py-3 px-2'>{client.phone}</td>
                    <td className='py-3 px-2'>{client.category}</td>
                    <td className='py-3 px-2'>{client.client_id}</td>
                    <td><button className='admin-btn rounded px-2 py-1' onClick={() => fetchSubClients(client)}>My Clients</button></td>
                    <td><button className='btn btn-danger rounded-circle px-2 py-0' onClick={() => deleteClients(client)}><i className="para-text fa-solid fa-xmark"></i></button></td>
                  </tr>
                ))
              )}

            </table>
          </div>
          {/* table ends */}


          {/* Show sub-clients if active client is selected */}
          {subClients && (
            <>
              <p className='sec-subheading'><hr /><span>Sub Clients of {activeClientName}</span><hr /></p>
              <div className='table-responsive text-center my-4'>
                <table className='w-100'>
                  <tr className='bg-light para-text'>
                    <th className='py-3 px-2'>S. No</th>
                    <th className='py-3 px-2'>Name</th>
                    <th className='py-3 px-2'>Phone</th>
                    <th className='py-3 px-2'>Role</th>
                    <th className='py-3 px-2'>User Id</th>
                    <th className='py-3 px-2'>Sub Clients</th>
                    <th className='py-3 px-2'>Delete Client</th>
                  </tr>
                  {subClients.length === 0 ? (
                    <tr>
                      <td colSpan='3' className='py-3 px-2'>
                        No sub-clients found.
                      </td>
                    </tr>
                  ) : (
                    subClients.map((subClient, index) => (
                      <tr className='text-muted para-text text-capitalize' key={subClient.id}>
                        <td className='py-3 px-2'>{index + 1}</td>
                        <td className='py-3 px-2'>{subClient.name}</td>
                        <td className='py-3 px-2'>{subClient.phone}</td>
                        <td className='py-3 px-2'>{subClient.category}</td>
                        <td className='py-3 px-2'>{subClient.client_id}</td>
                        <td><button className='admin-btn rounded px-2 py-1' onClick={() => fetchSubClients(subClient)}>My Clients</button></td>
                        <td><button className='btn btn-danger rounded-circle px-2 py-0' onClick={() => deleteClients(subClient)}><i className="para-text fa-solid fa-xmark"></i></button></td>
                      </tr>
                    ))
                  )}
                </table>
              </div>
            </>
          )}

        </div>
      </section>
    </>
  )
}

export default AdminClients
